import React from "react";
import App from "./App.js";
import "./index.css";
import { Loader, MantineProvider } from "@mantine/core";
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';

import '@splidejs/react-splide/css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { createRoot } from 'react-dom/client';
import ConfigContextProvider, { useConfigContext } from "./contexts/ConfigContext/ConfigContextProvider.js";


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
   <ConfigContextProvider>
      <WrappedApp />
   </ConfigContextProvider>
);


export default function WrappedApp() {
   const { theme, isReady } = useConfigContext();
   return (
      <MantineProvider theme={theme ?? null}>
         {isReady
            ? <>
               <Notifications zIndex={1000} />
               <App />
            </>
            : <div style={{ height: "100%", minHeight: "95vh", display: "flex", alignItems: "center", justifyContent: 'center' }}>
               <Loader size={30} />
            </div>
         }
      </MantineProvider >
   )
   // return (
   //    isReady
   //       ? <MantineProvider theme={theme} defaultColorScheme={theme.colorScheme}>
   //          <Notifications zIndex={1000} />
   //          <App />
   //       </MantineProvider>
   //       : <div style={{ height: "100%", minHeight: "95vh", display: "flex", alignItems: "center", justifyContent: 'center' }}>
   //          cargando
   //       </div>
   // )
}


